var map = {
	"./banner-carousel.de-CH.json": 1191,
	"./banner-carousel.de-DE.json": 1192,
	"./banner-carousel.en-CA.json": 1193,
	"./banner-carousel.en-GB.json": 1194,
	"./banner-carousel.en-IN.json": 1195,
	"./banner-carousel.en-ME.json": 1196,
	"./banner-carousel.en-US.json": 1197,
	"./banner-carousel.es-EM.json": 1198,
	"./banner-carousel.es-ES.json": 1199,
	"./banner-carousel.fr-BE.json": 1200,
	"./banner-carousel.fr-CA.json": 1201,
	"./banner-carousel.fr-CH.json": 1202,
	"./banner-carousel.nl-BE.json": 1203,
	"./banner-carousel.nl-NL.json": 1204,
	"./banner-carousel.pl-PL.json": 1205,
	"./banner-carousel.pt-BR.json": 1206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1190;